import { render, staticRenderFns } from "./BSidebarUI.vue?vue&type=template&id=0ca3cd1e&scoped=true"
import script from "./BSidebarUI.vue?vue&type=script&lang=js"
export * from "./BSidebarUI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca3cd1e",
  null
  
)

export default component.exports